/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import SectionCard from './SectionCard';
import SectionCardPlaceholder from './SectionCardPlaceholder';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import RenderOnCondition from './RenderOnCondition';

interface ISectionCardsProps {
  templateContext: TemplateContext;
}

export default function SectionCards(props: ISectionCardsProps): ReactElement {
  const template = props.templateContext.template;
  return (
    <>
      {template.sections.map((section, sectionIndex) => (
        <RenderOnCondition
          key={TemplateHelperPubSub.getPlaceholderKey(section.id, sectionIndex)}
          templateContext={props.templateContext}
          condition={section.condition}
        >
          {!section.placeholders || section.placeholders.length === 0 ? (
            <SectionCard templateContext={props.templateContext} section={section} />
          ) : (
            <SectionCardPlaceholder
              templateContext={props.templateContext}
              section={section}
              placeholder={section.placeholders[0]}
              placeholderIndex={0}
            />
          )}
        </RenderOnCondition>
      ))}
    </>
  );
}
